import React from 'react';
import AppIcon from './AppIcon';

// Destructive actions use the same symbol in every theme, including mobile.
export default function DeleteIcon() {
    return <AppIcon name="trash" size={16} className="app-delete-icon" />;
}
